<template>
  <div>
    <div class="search-pc">
      <SearchPC />
    </div>
    <div class="search-sp">
      <div class="search-button">
        <router-link to="/search-sp">
          <button><i class="las la-search"></i></button>
        </router-link>
      </div>
    </div>
    <div class="search-result">
      <SearchResultNumber />
    </div>
    <div class="job-list">
      <div class="job-item">
        <div class="left">
          <div class="position">
            <router-link to="/dashboard/job-pool/details">
              <h2>Senior Web Development</h2>
            </router-link>
            <div class="job-sticker">
              <JobStickerNew /><JobStickerUrgent /><JobStickerOffering /><JobStickerManyApplicants />
            </div>
          </div>
          <div class="location">
            <i class="las la-map-marker"></i
            ><span
              >BTS (Chidlom) , MRT Lines Lorem ipsum dolor sit amet consectetur
              adipisicing elit. Consectetur molestiae perspiciatis ipsa ad sunt
              sint vitae deserunt dolorum
            </span>
          </div>
          <div class="salary">
            <i class="las la-money-bill"></i
            ><span>35,000 THB - 50,000 THB</span>
          </div>
          <div class="post-date">
            <i class="las la-clock"></i><span>11 hours ago</span>
          </div>
        </div>
        <div class="right">
          <div class="jobid">
            <i class="la la-heart-o save-job"></i>
            <span class="id">ID: 123456</span>
          </div>
        </div>
      </div>
      <div class="job-item">
        <div class="left">
          <div class="position">
            <router-link to="/dashboard/job-pool/details">
              <h2>Senior Web Development</h2>
            </router-link>
            <div class="job-sticker">
              <JobStickerNew /><JobStickerUrgent /><JobStickerOffering /><JobStickerManyApplicants />
            </div>
          </div>
          <div class="location">
            <i class="las la-map-marker"></i
            ><span
              >BTS (Chidlom) , MRT Lines Lorem ipsum dolor sit amet consectetur
              adipisicing elit. Consectetur molestiae perspiciatis ipsa ad sunt
              sint vitae deserunt dolorum
            </span>
          </div>
          <div class="salary">
            <i class="las la-money-bill"></i
            ><span>35,000 THB - 50,000 THB</span>
          </div>
          <div class="post-date">
            <i class="las la-clock"></i><span>11 hours ago</span>
          </div>
        </div>
        <div class="right">
          <div class="jobid">
            <i class="la la-heart-o save-job"></i>
            <span class="id">ID: 123456</span>
          </div>
        </div>
      </div>
      <div class="job-item">
        <div class="left">
          <div class="position">
            <router-link to="/dashboard/job-pool/details">
              <h2>Senior Web Development</h2>
            </router-link>
            <div class="job-sticker">
              <JobStickerNew /><JobStickerUrgent /><JobStickerOffering /><JobStickerManyApplicants />
            </div>
          </div>
          <div class="location">
            <i class="las la-map-marker"></i
            ><span
              >BTS (Chidlom) , MRT Lines Lorem ipsum dolor sit amet consectetur
              adipisicing elit. Consectetur molestiae perspiciatis ipsa ad sunt
              sint vitae deserunt dolorum
            </span>
          </div>
          <div class="salary">
            <i class="las la-money-bill"></i
            ><span>35,000 THB - 50,000 THB</span>
          </div>
          <div class="post-date">
            <i class="las la-clock"></i><span>11 hours ago</span>
          </div>
        </div>
        <div class="right">
          <div class="jobid">
            <i class="la la-heart-o save-job"></i>
            <span class="id">ID: 123456</span>
          </div>
        </div>
      </div>
      <div class="job-item">
        <div class="left">
          <div class="position">
            <router-link to="/dashboard/job-pool/details">
              <h2>Senior Web Development</h2>
            </router-link>
            <div class="job-sticker">
              <JobStickerNew /><JobStickerUrgent /><JobStickerOffering /><JobStickerManyApplicants />
            </div>
          </div>
          <div class="location">
            <i class="las la-map-marker"></i
            ><span
              >BTS (Chidlom) , MRT Lines Lorem ipsum dolor sit amet consectetur
              adipisicing elit. Consectetur molestiae perspiciatis ipsa ad sunt
              sint vitae deserunt dolorum
            </span>
          </div>
          <div class="salary">
            <i class="las la-money-bill"></i
            ><span>35,000 THB - 50,000 THB</span>
          </div>
          <div class="post-date">
            <i class="las la-clock"></i><span>11 hours ago</span>
          </div>
        </div>
        <div class="right">
          <div class="jobid">
            <i class="la la-heart-o save-job"></i>
            <span class="id">ID: 123456</span>
          </div>
        </div>
      </div>
      <div class="job-item">
        <div class="left">
          <div class="position">
            <router-link to="/dashboard/job-pool/details">
              <h2>Senior Web Development</h2>
            </router-link>
            <div class="job-sticker">
              <JobStickerNew /><JobStickerUrgent /><JobStickerOffering /><JobStickerManyApplicants />
            </div>
          </div>
          <div class="location">
            <i class="las la-map-marker"></i
            ><span
              >BTS (Chidlom) , MRT Lines Lorem ipsum dolor sit amet consectetur
              adipisicing elit. Consectetur molestiae perspiciatis ipsa ad sunt
              sint vitae deserunt dolorum
            </span>
          </div>
          <div class="salary">
            <i class="las la-money-bill"></i
            ><span>35,000 THB - 50,000 THB</span>
          </div>
          <div class="post-date">
            <i class="las la-clock"></i><span>11 hours ago</span>
          </div>
        </div>
        <div class="right">
          <div class="jobid">
            <i class="la la-heart-o save-job"></i>
            <span class="id">ID: 123456</span>
          </div>
        </div>
      </div>

      <Pagination />
    </div>
  </div>
</template>
<script>
import SearchResultNumber from "../components/SearchResultNumber";
import JobStickerNew from "../components/job-sticker/JobStickerNew.vue";
import JobStickerUrgent from "../components/job-sticker/JobStickerUrgent.vue";
import JobStickerOffering from "../components/job-sticker/JobStickerOffering.vue";
import JobStickerManyApplicants from "../components/job-sticker/JobStickerManyApplicants.vue";
import JobStickerNoApplicant from "../components/job-sticker/JobStickerNoApplicant.vue";
import SearchPC from "../components/SearchPC.vue";
import Pagination from "../../components/ui/Pagination";
export default {
  name: "DashboardJobPool",
  components: {
    Pagination,
    SearchResultNumber,
    JobStickerNew,
    JobStickerUrgent,
    JobStickerOffering,
    JobStickerManyApplicants,
    JobStickerNoApplicant,
    SearchPC,
  },
  data() {
    return {
      readMore: false,
    };
  },
};
</script>
<style scoped lang="scss">
@import "@/assets/stylesheets/application";
.search-pc {
  display: block;
  margin-bottom: 2rem;
}
.search-sp {
  display: none;
}
.search-result {
  padding-bottom: 3rem;
}
.job-list {
  .job-item {
    align-items: stretch;
    background: #fafafa;
    display: flex;
    flex-direction: row;
    margin-bottom: 1rem;
    padding: 1.5rem 1.25rem;
    width: 100%;
    .left {
      flex: auto;
      width: 70%;
      a {
        &:hover .position h2,
        &:focus {
          filter: contrast(150%);
        }
      }
      .position {
        display: flex;
        flex-direction: column;
        margin-bottom: 0.5rem;
        h2 {
          font-size: 1.25em;
          transition: 0.4s all ease-in-out;
          margin-right: 5px;
          width: min-content;
          width: 100%;
          margin-bottom: 5px;
        }
        .job-sticker {
          display: flex;
          & > * {
            margin-right: 4px;
          }
        }
      }
      .location,
      .salary,
      .post-date {
        align-items: flex-start;
        display: flex;
        flex-direction: row;
        line-height: 1.75rem;

        i {
          color: $blue-primary;
          font-size: 20px;
          margin-right: 10px;
          margin-top: 3px;
        }
        span {
          color: $black;
          font-size: 1em;
          font-weight: 600;
        }
      }
      .location {
        span {
          font-weight: 500;
        }
      }
      .post-date {
        i {
          color: $gray;
          font-size: 16px;
          margin-right: 10px;
          margin-top: 3px;
        }
        span {
          color: $gray;
          font-size: 12px;
          font-weight: normal;
        }
      }
    }
    .right {
      width: 30%;
      display: flex;
      justify-content: end;
      .jobid {
        display: flex;
        flex-direction: column;
        align-items: end;
        justify-content: space-between;
        .save-job {
          font-size: 24px;
          color: #3742fa;
        }
        .id {
          color: $gray;
          font-size: 1.15em;
          font-weight: 700;
        }
      }
      .button {
        .btn {
          display: inline-flex;
          font-size: 12px;
          padding: 8px 10px;
        }
      }
    }
  }
}

@media only screen and (max-width: 991px) {
  .search-pc {
    display: none;
  }
  .search-sp {
    display: block;
    position: fixed;
    z-index: 1000;
    bottom: 30px;
    right: 15px;
    .search-button {
      button {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 60px;
        height: 60px;
        background: #3742fa;
        border-radius: 100rem;
        &:hover,
        &:focus {
          filter: contrast(150%);
        }
        .la-search {
          font-size: 30px;
          color: white;
        }
      }
    }
  }
  .job-list {
    .job-item {
      margin-bottom: 1rem;
      padding: 1rem 1rem;
      .left {
        width: 60%;
        .position {
          h2 {
            display: -webkit-box;
            font-size: 1em;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
          }
        }
        .location,
        .salary,
        .post-date {
          line-height: 1.75rem;

          i {
            font-size: 16px;
            margin-right: 8px;
            margin-top: 3px;
          }
          span {
            font-size: 12px;
          }
        }
        .location {
          span {
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1;
            overflow: hidden;
          }
        }
        .post-date {
          i {
            font-size: 14px;
            margin-right: 5px;
          }
          span {
            font-size: 10px;
          }
        }
      }
      .right {
        width: 40%;
        .jobid {
          font-size: 12px;
        }
        .button {
          .btn {
            border: 0;
            display: inline-flex;
            font-size: 12px;
            padding: 0;
            text-decoration: underline;
            &:focus {
              color: $blue-primary;
            }
          }
        }
      }
    }
  }
}
</style>
